module.exports = __webpack_public_path__ + "img/ic_pin_warehouse.46a3ae07.png";